import React from 'react';
import { Home, Camera, ShoppingBag, MessageCircle, User } from 'lucide-react';
import '../styles/components/Navigation.css';

const Navigation = ({ activeTab, setActiveTab }) => {
   const tabs = [
      { id: 'home', icon: Home, label: 'Home' },
      { id: 'post', icon: Camera, label: 'Post' },
      { id: 'shop', icon: ShoppingBag, label: 'Shop' },
      { id: 'ai', icon: MessageCircle, label: 'AI Stylist' },
      { id: 'profile', icon: User, label: 'Profile' }
   ];

   return (
      <div className="navigation-container">
         <div className="nav-tabs">
            {tabs.map(({ id, icon: Icon, label }) => (
               <button
                  key={id}
                  onClick={() => setActiveTab(id)}
                  className={`nav-tab ${activeTab === id ? 'nav-tab-active' : 'nav-tab-inactive'}`}
               >
                  <Icon size={20} />
                  <span className="nav-label">{label}</span>
               </button>
            ))}
         </div>
      </div>
   );
};

export default Navigation;